import { Box, DataList, HoverCard, HStack, Text, VStack } from "@chakra-ui/react"
import React from "react"
import { format as formatDate } from "date-fns"
import * as gqlTypes from "@hydrologiq/gql-experience/graphql"
import { toUserTZ } from "@hydrologiq/common/helpers/date"

interface OrderCellHoverProps {
  order?: gqlTypes.AssetActivityOrder
  quantity?: number
  quantityPlanned?: number
  percentPlanned?: number
  startDate?: string
  endDate?: string
  color?: string
  backgroundColor?: string
  children: React.ReactNode
  left?: number
  top?: number
  open?: boolean
}

const OrderCellHover = ({
  order,
  quantity = 0,
  quantityPlanned = 0,
  percentPlanned = 0,
  startDate,
  endDate,
  color = "white",
  backgroundColor = "#CDEFDD",
  children,
  left = 0,
  top = 0,
  open,
}: OrderCellHoverProps) => {
  return (
    <HoverCard.Root open={open} positioning={{ placement: "bottom-start" }}>
      <HoverCard.Trigger asChild>
        <Box
          position="fixed"
          left={`${left}px`}
          top={`${top}px`}
          width="1px"
          height="1px"
          visibility="hidden"
          pointerEvents="none"
        >
          {children}
        </Box>
      </HoverCard.Trigger>
      <HoverCard.Positioner zIndex={1000}>
        <HoverCard.Content p={3} maxW="320px">
          {order && <DataList.Root orientation="horizontal" gap={0}>
            <DataList.Item key="order">
              <DataList.ItemLabel>Order:</DataList.ItemLabel>
              <DataList.ItemValue>{order?.name}</DataList.ItemValue>
            </DataList.Item>
            <DataList.Item key="quantity">
              <DataList.ItemLabel>Quantity:</DataList.ItemLabel>
              <DataList.ItemValue>{quantity}g</DataList.ItemValue>
            </DataList.Item>
            <DataList.Item key="planned">
              <DataList.ItemLabel>Planned:</DataList.ItemLabel>
              <DataList.ItemValue>{percentPlanned}% ({quantityPlanned} kg / {quantity} kg)</DataList.ItemValue>
            </DataList.Item>
            <DataList.Item key="startDate">
              <DataList.ItemLabel>Start Date:</DataList.ItemLabel>
              <DataList.ItemValue>{startDate ? formatDate(new Date(toUserTZ(startDate).unixUtcMillis()), "dd/MM/yyyy") : "—"}</DataList.ItemValue>
            </DataList.Item>
            <DataList.Item key="endDate">
              <DataList.ItemLabel>End Date:</DataList.ItemLabel>
              <DataList.ItemValue>{endDate ? formatDate(new Date(toUserTZ(endDate).unixUtcMillis()), "dd/MM/yyyy") : "—"}</DataList.ItemValue>
            </DataList.Item>
          </DataList.Root>}

        </HoverCard.Content>
      </HoverCard.Positioner>
    </HoverCard.Root>
  )
}

export default OrderCellHover
